<template>
    <div class="right-content">
        <div class="right-content-title"></div>
        <div class="right-content-body">
            <div class="title">
                环境
            </div>
            <div class="content">
                <p class="bold bigger">宇宙环境</p>
                <div class="content-text-with-imgs">
                    <div class="left-text">
                        <p class="indent">地球属于银河系太阳系，处在金星与火星之间，是太阳系中距离太阳第三近的行星，有一颗卫星。地球是目前发现一个具有生命个体的行星。</p>
                        <p class="indent">地球所处的宇宙环境是指以地球为中心的宇宙环境，可以从宏观和微观两个层面理解。宏观层面上是指地球在天体系统中所处的位置，即地月系—太阳系—银河系—总星系；微观层面上是指地球在太阳系中所处的位置。在无限的宇宙空间中，地球只不过是沧海之一粟，它处在永不止息的运动中。</p>
                    </div>
                    <div class="right-text-img">
                        <div class="right-image">
                            <img src="../../assets/images/eabiao.jpg" />
                        </div>
                        <div class="right-text">
                            <img src="../../assets/artist-text/earth-surface.png" width="60%">
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>

                <p class="bold bigger">内部环境</p>
                <p class="indent">地面早已绝迹的动物，难道地球内部真的存在一个世外桃源吗？</p>
                <p class="indent">远在1904年，美国加利福尼亚卡斯特山脉中一个叫布朗的采矿者，发现一处类似巨人住的人工地道。洞穴中有用巨大铜锁住的巨大房舍，墙壁间有黄金铸成的盾和从未见过的物品，墙壁上还画着奇怪的图画和文学。</p>
                <p class="indent">第二次大战期间，美国陆军上士兵希伯在和侵缅日军战斗中与战友失散被遗留森林，有一天他无意中发现一处被巨石隐蔽的洞口。希伯冒险进入洞内，竟然发现里面被人工光源照得亮如白昼，俨然是一处庞大的地下城市。希伯正看得惊迷时，突然被抓住，一关就是4年，后寻机拼命逃出。据他说这个地下王国通向地面的隧道有7条，分别在世界其它一些地方开有秘密出入口。</p>
                <p class="indent">1968年1月美国TG石油公司勘探队在土耳其西方大洞穴地下270米的地方，发现地底深邃的岩盘隧道，洞内高约4--5米，洞壁洞顶光滑明亮，显然为人工磨成。洞内到处是蛛网似的横洞，俨然一个令人扑朔迷离的迷宫。
                    或许有人会问，若真的存在这个地下王国，那么他们为什么不回到阳光明媚的地面来生活呢?答案似乎只有一个：这个地下王国的居民长居在地下，或已演化成嗜热的硅生命体，已不可能再适应地面的生活。</p>
                <p class="indent">有一点是肯定的，假设地下王国真的存在，那么他们必定掌握着高于地表人的科学技术，诸如飞碟等一系列所谓之谜也就不难获得答案了。且不说是否真的存在着一个地下王国，难道地球内部确是空的吗?不少地球物理专家认为，地球的现有重量是6兆吨的百万倍，假如地球内部不是空的，它的重量应远不止此。</p>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "EnvironmentView"
    }
</script>

<style lang="scss" scoped>
    .split-style {
        text-align: center;
        .split-style-span1 {
            width: 10px;
            height: 2px;
            margin-left: 5px;
            display: inline-block;
            background: #000;
        }
        .split-style-span {
            width: 15px;
            height: 4px;
            margin-left: 5px;
            display: inline-block;
            background: #000;
            box-shadow: 5px 6px #5A656E;
        }
    }
    .right-content {
        padding: 30px;
        margin-left: 130px;
        font-size: 13px;
        .title {
            text-align: center;
        }
        .bigger {
            font-size: 18px;
        }
        .right-content-body {
            max-height: 620px;
            overflow-y: auto;
            overflow-x: hidden;
            .title {
                -webkit-text-stroke: 0.05em #33c;
                -webkit-text-fill-color : transparent;
                font-size: 30px;
                text-shadow: 3px 3px 2px #b2b2b2;
                text-align: left;
                font-family: SimSun;
            }
            -ms-overflow-style: none;
            overflow: -moz-scrollbars-none;

            &::-webkit-scrollbar {
                width: 0 !important
            }
            .content-text-with-imgs {
                .left-text {
                    float: left;
                    width: 60%;
                }
                .right-text-img {
                    text-align: center;
                    float: right;
                    width: 40%;
                }
                .right-text {
                    -webkit-text-stroke: 0.03em #000000;
                    -webkit-text-fill-color: transparent;
                    font-size: 40px;
                    text-shadow: 3px 3px 1px #b2b2b2;
                    font-family: SimSun;
                    font-style: italic;
                }
            }
        }
    }
</style>